/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedBlurbSupportNumber_viewer$ref = any;
export type PdpSharedBlurbSupportNumber_viewer = {
    readonly isEnabled: boolean | null;
    readonly contactInfo: {
        readonly phoneNumbers: {
            readonly support: string | null;
        } | null;
    } | null;
    readonly " $refType": PdpSharedBlurbSupportNumber_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedBlurbSupportNumber_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "PDP_SUPPORT_NUMBER_BLURB"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"PDP_SUPPORT_NUMBER_BLURB\")"
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "contactInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "ContactInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "phoneNumbers",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "support",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "support",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "formatType",
                                    "value": "INTERNATIONAL"
                                }
                            ],
                            "storageKey": "support(formatType:\"INTERNATIONAL\")"
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '500246412867f3f2b0fd4c36ab4a2fdf';
export default node;
